
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2076.12-1775.776l12.9 12.9a.869.869 0 00.42.234 1.032 1.032 0 00.488 0 .931.931 0 00.674-.674 1.032 1.032 0 000-.488.869.869 0 00-.234-.42l-12.9-12.9a.931.931 0 00-.43-.234 1.076 1.076 0 00-.488 0 .831.831 0 00-.43.249.931.931 0 00-.234.43 1.032 1.032 0 000 .488.869.869 0 00.234.415zm0 11.553a.905.905 0 00-.239.42 1.011 1.011 0 000 .493.837.837 0 00.244.425.894.894 0 00.43.244 1.032 1.032 0 00.488 0 .931.931 0 00.43-.234l12.9-12.9a.869.869 0 00.234-.42 1.052 1.052 0 000-.493.837.837 0 00-.244-.425.894.894 0 00-.435-.244 1.032 1.032 0 00-.488 0 .869.869 0 00-.415.234z"}})])])
          )
        }
      }
    